import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MyAccountService {

  constructor(private http: HttpClient) { }

  public parentInitEvent: EventEmitter<void> = new EventEmitter<void>();

  getUserProfileDetails(userId: number): Observable<any> {
    const url = environment.apiURL + `api/user-profile/${userId}`;
    return this.http.get(url);
  }

  getUserRoles(): Observable<any> {
    const url = environment.apiURL + `api/user/roles`;
    return this.http.get(url);
  }

  updateMyInformation(payload: any, userId: number): Observable<any> {
    const url = environment.apiURL + `api/user-profile/${userId}/my-information`;

    return this.http.post(url, payload);
  }


  updateWords(userId: number, data: any): Observable<any> {
    const url = environment.apiURL + `api/users/${userId}/account/my-words`;

    const headers = { 'content-type': 'application/json' };
    
    const params = new HttpParams().set('myWords', data);
    
    return this.http.post(url, null, {
      responseType: 'text',
      headers: headers,
      params: params
    });
  }


  updatePassword(newpassword: any, userId: number): Observable<any> {
    const url = environment.apiURL + `api/users/${userId}/account/updatePassword`;

    const headers = { 'content-type': 'application/json' };

    const params = new HttpParams().set('newPassword', newpassword);

    return this.http.post(url, null, {
      responseType: 'text',
      headers: headers,
      params: params
    });
    
  }

  updateIAmFanOf(payload: any, userId: number): Observable < any > {
    const url = environment.apiURL + `api/user-profile/${userId}/fanOf`;
    
    return this.http.post(url, payload)
  }

  updateIAmCreatorOf(payload: any, userId: number): Observable<any> {
    const url = environment.apiURL + `api/user-profile/${userId}/creatorOf`;

    return this.http.post(url, payload)
  }

  getNotifications(userId: number): Observable<any> {
    const url = environment.apiURL + `api/users/${userId}/account/account_my_notifications`;
    return this.http.get(url);
  }

  updateBackgroundImage(data: any): Observable<any> {
    const url = environment.apiURL + `api/user-profile/userId/account/updateBackgroundImage`;

    const formData = new FormData();
    let params: HttpParams = new HttpParams();

    if (data.backgroundId !== null) {
      params = params.set('backgroundId', data.backgroundId);
      formData.append('file', 'string');
    }

    if (data.file !== undefined || data.file != null) {
      formData.append('file', data.file);
      params = params.set('backgroundId', '0')
    }

    return this.http.post(url, formData, {
      params,
      responseType: 'text'
    });

  }

  getBackgroundImages(userId: number): Observable<any> {
    const url = environment.apiURL + `api/users/${userId}/account/account_my_background_picture`;
    return this.http.get(url);
  }

  getPointsHistory(userId: number): Observable<any> {
    const url = environment.apiURL + `api/users/${userId}/account/account_my_point_history`;
    return this.http.get(url);
  }

  getContestHistory(userId: number): Observable<any> {
    const url = environment.apiURL + `api/users/${userId}/account/account_my_contest_history`;
    return this.http.get(url);
  }

  getPaymentHistory(userId: number): Observable<any> {
    const url = environment.apiURL + `api/users/${userId}/account/account_my_purchase_history`;
    return this.http.get(url);
  }

  removeIAmVideo(userId: number): Observable<any> {
    const url = environment.apiURL + `api/users/${userId}/account/removeVideo`;
    return this.http.get(url);
  }

  removeMyProfilePicture(userId: number): Observable<any> {
    const url = environment.apiURL + `api/user-profile/${userId}/profilePic`;
    return this.http.delete(url);
  }

  updateMyProfilePicture(data: any, userId: number): Observable<any> {
    const url = environment.apiURL + `api/user-profile/${userId}/profilePic`;

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');

    return this.http.post(url, data, { headers });
  }

  getPatronUnsubscribe(): Observable<any> {
    const url = environment.apiURL + `api/patron/unsubscribe`;
    return this.http.get(url);
  }
  removeUserAccount(){
    const url = environment.apiURL + `api/user/delete`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  
    const requestBody = {};
  
    return this.http.post(url, requestBody, { headers });
  }
}